
<template>
  <el-checkbox-group
    class="checkbox-group"
    v-model="value"
    :size="size"
    @change="changeList"
  >
    <el-checkbox
      v-for="item in infoData"
      :key="item.value"
      :label="item.value"
      :disabled="item.disabled"
      >{{ item.label }}</el-checkbox
    >
  </el-checkbox-group>
</template>
<script>
export default {
  name: 'CheckboxGroup',
  props: {
    name: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'mini',
    },
  },
  data() {
    return {
      infoData: this.data,
      value: [],
    };
  },
  watch: {
    data: {
      handler(val) {
        return (this.infoData = val);
      },
    },
  },
  methods: {
    changeList() {
      this.$emit('change-list', this.value, this.name);
    },
    onReset() {
      this.value = [];
    },
  },
};
</script>
<style lang="less" scoped>
.checkbox-group {
  margin-left: 10px;
  // margin-top: 4px;
}
</style>
